import { Styles, css, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  section: ({ theme }) => css`
    display: flex;
    flex-direction: column;
    width: 100%;
    border: 1px solid ${theme.colors.neutral.variant[10]};
    border-radius: 14px;
  `,
  sectionTitle: ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 16px 12px;
    background: ${theme.colors.neutral.variant[10]};
    color: ${theme.colors.neutral.variant[60]};
    border-top-left-radius: 14px;
    border-top-right-radius: 14px;
  `,
  sectionContent: css`
    display: flex;
    flex-grow: 1;
    padding: 16px 12px;
    overflow: hidden;
  `,
  sectionTimeline: css`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 16px;
  `,
  horizontalSectionContent: css`
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    row-gap: 8px;
    column-gap: 8px;
  `,
  timelineItem: ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 8px;
    position: relative;
    padding-left: 24px;

    &::before {
      content: '';
      position: absolute;
      left: 8px;
      top: 8px;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: ${theme.colors.neutral.variant[30]};
    }

    &:not(:last-child)::after {
      content: '';
      position: absolute;
      left: 11px;
      top: 16px;
      width: 2px;
      height: calc(100% + 8px);
      background-color: ${theme.colors.neutral.variant[20]};
    }
  `,
  timelineItemHeader: css`
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding-top: 2px;
  `,
  timelineItemMeta: css`
    display: flex;
    align-items: center;
    gap: 8px;
  `,
  timelineButton: css`
    cursor: pointer;
  `,
  listItem: css`
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
  `,
  pillsContainer: css`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    max-width: 100%;
  `,
  textContent: css`
    width: 100%;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
